import { generateID } from '@/lib/utils'
/* eslint-disable */
function loadScript() {
  if (window.ysf) return window.ysf
  return new Promise(resolve => {
    ;(function(w, d, n, a, j = {}) {
      w[n] =
        w[n] ||
        function() {
          return (w[n].a = w[n].a || []).push(arguments)
        }
      j = d.createElement('script')
      j.async = true
      j.src = '//qiyukf.com/script/e7172fc844d88cd3ae196678ea38da5e.js'
      j.onload = () => {
        if (!w[n]) return setTimeout(() => {
          resolve(w[n])
        }, 1000)
        resolve(w[n])
      }
      d.body.appendChild(j)
    })(window, document, 'ysf')
  })
}

function configQiYuSdk({ uuid, name, email, mobile }, config = {}) {
  let qiyuLoginData = localStorage.getItem('qiyu_login_data')
  if (!qiyuLoginData) {
    localStorage.setItem('qiyu_login_data', generateID())
    qiyuLoginData = localStorage.getItem('qiyu_login_data')
  }
  
  // eslint-disable-next-line no-undef
  window.ysf('config', Object.assign({
    uid: uuid || qiyuLoginData,
    name,
    email,
    mobile,
    groupid: '398550496', //  公有云-分组
    welcomeTemplateId: 705, // 公有云-机器人欢迎语 id
    qtype: 2894516, //  公有云-常见问题模板id
    robotId: '3464821', //  公有云-机器人ID
    robotShuntSwitch: 1, // 机器人优先开关
    data: JSON.stringify([
      { key: 'real_name', value: name }, // 姓名
      { key: 'mobile_phone', value: mobile }, // 手机号
      { key: 'email', value: email }, // 邮箱
    ]),
    success() {
      console.log('qiyu 配置成功')
    },
    error() {
      console.log('qiyu 配置 失败')
    },
  }, config))
}

let isSdkReady = false

function ready(user, config) {
  if (isSdkReady) return ysf
  return new Promise(resolve => {
    window.ysf('onready', () => {
      configQiYuSdk(user, config)
      isSdkReady = true
      resolve(ysf)
    })
  })
}

export async function openYsf(user = {}, config = {}) {
  let ysf = await loadScript()
  await ready(user, config)
  ysf('open')
  return ysf
}

export async function createYsf(user = {}, config = {}) {
  let ysf = await loadScript()
  await ready(user, config)
  return ysf
}
